// hooks/useFileUpload.js
import { useState } from 'react'
import axios from 'axios'

export const useFileUpload = () => {
  const [progress, setProgress] = useState(0)

  const uploadFile = async (file) => {
    const formData = new FormData()
    formData.append('file', file)

    try {
      await axios({
        url: '/api/googleCloud/upload',
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: 'formData' || null,
      })
      /*await axios.post('/api/googleCloud', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                /!*onUploadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    setProgress(Math.round((loaded / total) * 100));
                },*!/
            });*/
    } catch (error) {
      console.error('Upload failed:', error)
    }
  }

  return { progress, uploadFile }
}
